import { useMemo, useState, useCallback, useEffect } from 'react';
import { FEEDBACK_STATE } from '../FeedbackBlock/FeedbackBlock';
import { useForm } from 'react-hook-form';

export const useCompleteTaskModal = ({ isOpen, onSubmit }) => {
  const [feedbackState, setFeedbackState] = useState(FEEDBACK_STATE.NONE);

  const { reset, handleSubmit, register } = useForm();

  useEffect(() => {
    if (isOpen) {
      setFeedbackState(FEEDBACK_STATE.NONE);
      reset();
    }
  }, [isOpen]);

  const handleFeedbackChange = useCallback(
    state => () => {
      setFeedbackState(state);
    },
    []
  );

  const textAreaLabel = useMemo(() => {
    if (feedbackState === FEEDBACK_STATE.POSITIVE) {
      return '🎉 How did the task help you?';
    } else if (feedbackState === FEEDBACK_STATE.NEGATIVE) {
      return '🙁 How can we improve future tasks?';
    } else {
      return 'Tell us more';
    }
  }, [feedbackState]);

  const submitFeedback = useCallback(
    data => {
      onSubmit(feedbackState, data.comments);
    },
    [feedbackState, onSubmit]
  );

  const onSkip = useCallback(
    e => {
      e?.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return {
    textAreaLabel,
    feedbackState,
    handleFeedbackChange,
    submit: e => {
      e?.preventDefault();
      handleSubmit(submitFeedback)();
    },
    register,
    onSkip,
  };
};
